import { KJORETOYTYPER_SUCCESS } from "./kjoretoytyperActions";

const kjoretoytyperReducer = (state = [], action = {}) => {
  switch (action.type) {
    case KJORETOYTYPER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export const getState = state => state.kjoretoytyper;

export default kjoretoytyperReducer;
